import { API } from "helpers";

export const login = (name: string, password: string) => {
  return API({}, {}).post("user/login/", {
    name,
    password,
  });
};

export const getPermissions = (sec_groups: string[]) => {
  return API({}, {
    "Authorization": localStorage.getItem("bearerToken"),
  }).post("user/permissions/", {
    sec_groups,
  });
};

export const getPrivacyPreference =(id : string) => {
  return API({},{
    "Authorization": localStorage.getItem("bearerToken"),
  }).get('privacyPreference/getCustomerPrivacyPrefernce/${id}');
};

export const getAcquiaToken = () => {
  return API({}, {
    "Authorization": localStorage.getItem("bearerToken"),
  }).get("acquia/token/", {});
};

export const getConfig = () => {
  return API({}, {
    "Authorization": localStorage.getItem("bearerToken"),
  }).get("config", {});
};
